import _extends from "@babel/runtime/helpers/esm/extends";
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { StyledVerticalNavItem } from './VerticalNavItem.styles';
/**
 * A simple container for a `VerticalNav` item. Usually has an `Anchor` or an
 * `UnstyledButton` as a child.
 *
 * @since 8.72.0
 */

export var VerticalNavItem = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(StyledVerticalNavItem, _extends({
    ref: forwardedRef
  }, props));
});
VerticalNavItem.displayName = 'VerticalNavItem';
VerticalNavItem.propTypes = {
  /**
   * If true, displays the item in its "disabled" state.
   */
  'aria-disabled': PropTypes.bool,
  /**
   * If true, displays the item in its "selected" state.
   *
   * This should only be used if the nav item is like a tab
   */
  'aria-selected': PropTypes.bool,
  /**
   * If anything but false, displays the item in its "selected" state.
   *
   * Don't use aria-current as a substitute for aria-selected in gridcell, option, row or tab
   */
  'aria-current': PropTypes.oneOf(['page', 'step', 'location', 'date', 'time', 'true', 'false', true, false]),
  /**
   * Item text content.
   */
  'children': PropTypes.node.isRequired
};
VerticalNavItem.defaultProps = {};